import { IProgramDT } from "@/types/program-d-t";

export const university_classic_program_data: IProgramDT[] = [
  {
    id: 1,
    img: "/assets/img/program/program-thumb-1.webp",
    title: "Engineering Technology",
    titleAr: "كلية الهندسة التكنولوجية",
    alt: "A woman in a green lab coat and hijab adjusting a robotic arm in a technology lab, surrounded by industrial equipment and glowing orange lights.",
    altAr:
      "امرأة ترتدي معطف مختبر أخضر وحجاب، تعدل ذراعًا روبوتيًا في مختبر تكنولوجيا، محاطة بمعدات صناعية وأضواء برتقالية متوهجة.",
    description:
      "A cutting-edge STEM school offering high-quality technical education that integrates creativity, real-world projects, and scientific research, empowering students with leadership and innovation skills.",
    descriptionAr:
      "كلية علميّة حديثة تقدّم تعليمًا  تقنيًا عالي الجودة يجمع بين الإبداع، والمشاريع الحقيقية، والبحث العلمي، مما يمكّن الطلبة من اكتساب مهارات القيادة والابتكار.",
    category: "Economics",
    href: "/schools/set",
  },
  {
    id: 2,
    img: "/assets/img/program/program-thumb-2.webp",
    title: "Computing and Informatics",
    titleAr: "كلية الحاسوب والمعلوماتية",
    alt: "A woman in a hijab is seated at a computer, focused on her work in a bright and organized workspace.",
    altAr:
      "امرأة ترتدي حجابًا تجلس أمام جهاز كمبيوتر، تركز على عملها في مساحة عمل مشرقة ومنظمة.",
    description:
      "The school's programs address the growing demand for skilled IT professionals, equipping them to design and build next-generation information systems for the private and public sectors.",
    descriptionAr:
      " توفّر الكليّة برامج تواكب الطلب المتزايد على الكفاءات في تكنولوجيا المعلومات، وتؤهل الطلبة لتصميم وبناء أنظمة معلوماتية متقدمة للقطاعين العام والخاص.",
    category: "Business & Administration",
    href: "/schools/sci",
  },
  {
    id: 3,
    img: "/assets/img/program/program-thumb-3.webp",
    title: "Built Environment Engineering",
    titleAr: "كلية هندسة البيئة المبنيّة",
    alt: "A woman in a professional setting, working on architectural or engineering designs at a desk, with a scale model of buildings and technical drawings in the foreground.",
    altAr:
      "امرأة في بيئة مهنية، تعمل على تصميمات معمارية أو هندسية على مكتب، مع نموذج مقياس للمباني ورسومات فنية في المقدمة.",
    description:
      "Built environment engineering focuses on structures and systems like cities, buildings, roads, and bridges, covering fields such as architecture, civil engineering, urban planning, and construction management.",
    descriptionAr:
      "تركز الكليّة على تصميم الهياكل والأنظمة مثل المدن والمباني والطرق والجسور، وتشمل مجالات كالهندسة المعمارية والمدنية والتخطيط الحضري وإدارة الإنشاءات.",
    category: "Sciences",
    href: "/schools/sbee",
  },
  {
    id: 4,
    img: "/assets/img/program/program-thumb-4.webp",
    title: "Social and Basic Sciences",
    titleAr: "كليّة العلوم الاجتماعيّة والأساسيّة",
    alt: "A young man in a library setting, sitting in a modern study area, reading a book with other textbooks placed on the table in front of him.",
    altAr:
      "شاب في مكتبة، يجلس في منطقة دراسة حديثة، يقرأ كتابًا مع كتب دراسية أخرى موضوعة على الطاولة أمامه.",
    description:
      "Provides courses designed to equip students with the skills and tools needed to thrive in a dynamic, global workplace.",
    descriptionAr:
      "تقدم الكليّة مساقات تزوّد الطلبة بالمهارات والأدوات اللازمة للنجاح في بيئة عمل ديناميكية وعالمية.",
    category: "Sciences",
    href: "/schools/ssbs",
  },
];

export const high_school_program_data: IProgramDT[] = [
  {
    id: 1,
    img: "/assets/img/schools/School of Engineering Technology.webp",
    title: "School of Engineering Technology",
    titleAr: "كليّة الهندسة التكنولوجيّة",
    description: "British National Curriculum",
    descriptionAr: "المنهج الوطني البريطاني",
    category: "Childhood Education",
    age: "3-5 years",
    time: "8:00 AM - 12:00 PM",
    size: "Small Class Size",
    alt: "",
    href: "/schools/set",
  },
  {
    id: 2,
    img: "/assets/img/schools/School of Computing and Informatics.webp",
    title: "School of Computing and Informatics",
    descriptionAr: "كلية الحاسوب والمعلوماتيّة",
    description: "Cambridge Primary",
    titleAr: "كلية الحاسوب والمعلوماتيّة",
    category: "Primary Education",
    age: "6-10 years",
    time: "8:00 AM - 2:00 PM",
    size: "Medium Class Size",
    alt: "",
    href: "/schools/sci",
  },
  {
    id: 3,
    img: "/assets/img/schools/School of Built Environment Engineering.webp",
    title: "School of Built Environment Engineering",
    titleAr: "كليّة هندسة البيئة المبنيّة",
    description: "Cambridge Secondary",
    descriptionAr: "الكلية الثانوية كامبريدج",
    category: "Secondary Education",
    age: "11-14 years",
    time: "8:00 AM - 3:00 PM",
    size: "Medium Class Size",
    alt: "",
    href: "/schools/sbee",
  },
  {
    id: 4,
    img: "/assets/img/schools/School of Social and Basic Sciences.webp",
    title: "School of Social and Basic Sciences",
    titleAr: "كليّة العلوم الاجتماعيّة والأساسيّة",
    description: "Cambridge AS & A Level",
    descriptionAr: "الكلية الثانوية كامبريدج",
    category: "Higher Education",
    age: "15-18 years",
    time: "8:00 AM - 4:00 PM",
    size: "Large Class Size",
    alt: "",
    href: "/schools/ssbs",
  },
];
